export default "__VITE_ASSET__B66PsHL0__"